(function () {
  function sizeToken(v) {
    if (v.indexOf(' - ') !== -1) {
      var parts = v.split(' - ');
      return parts[parts.length - 1].trim();
    }
    return v.trim();
  }

  // ---- Italian bra sizes (IT market only)
  // Italy numbers the band instead of naming its centimetres: 70=1, 75=2, 80=3,
  // 85=4, 90=5; the cup letter is unchanged. Product option values are
  // translated server-side (scripts/set_it_bra_sizes.py), which covers the
  // native variant picker and the cart — but Simple Bundles writes its own
  // select values, so the tiles built from them are converted here instead.
  //
  // That leaves the two sides speaking different systems on /it-it/: the stock
  // map is keyed by (translated) variant titles, the selects by untranslated
  // ones. euSize() folds both back to EU when the map is parsed, so every
  // lookup below stays a plain `variants[euToken]`.
  var IT_BANDS = { 70: 1, 75: 2, 80: 3, 85: 4, 90: 5, 95: 6, 100: 7 };
  var EU_SIZE = /^(\d{2,3})([A-K]{1,2})$/;
  var IT_SIZE = /^([1-7])([A-K]{1,2})$/;

  function itSize(token) {
    var m = EU_SIZE.exec(token);
    var band = m && IT_BANDS[m[1]];
    return band ? band + m[2] : token;
  }
  function euSize(token) {
    var m = IT_SIZE.exec(token);
    return m ? String(m[1] * 5 + 65) + m[2] : token;
  }
  // snippets/gb-size-links.liquid flags the IT market on the stock payload.
  function itSizesOn() {
    var el = document.querySelector('script[data-gb-stock]');
    return !!el && el.getAttribute('data-gb-it-sizes') === 'true';
  }
  function displaySize(token) {
    return itSizesOn() ? itSize(token) : token;
  }

  // All bundle component selects on the page (Simple Bundles renders these as
  // line-item property selects).
  function bundleSelects() {
    return Array.prototype.slice.call(document.querySelectorAll('select[name^="properties["]'));
  }
  function isChosen(sel) {
    return sel.selectedIndex >= 0 && !!sel.value;
  }

  // Regular (non-bundle) products: the native variant picker's size buttons.
  // variant-main-picker.liquid no longer preselects one, so these start empty
  // and get gated exactly like the bundle size groups.
  // Swatch options carry .variant-option--buttons too, and they keep their
  // preselection (a colour has to resolve to something), so exclude them —
  // this gate is only about the button-style options the Liquid stopped
  // preselecting.
  // Scoped to the template's own picker ([data-template-product-match]), so a
  // quick-add dialog opened from the recommendations rail can never gate the
  // main form — it carries its own picker and its own button.
  function sizeFieldsets() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        'variant-picker[data-template-product-match="true"] ' +
          'fieldset.variant-option--buttons:not(.variant-option--swatches)'
      )
    );
  }
  function fieldsetChosen(fs) {
    return !!fs.querySelector('input[type="radio"]:checked');
  }

  // Is the chosen size an unavailable option value? Horizon marks those inputs
  // (the struck-through tiles) and disables its own button for them. Now that
  // this gate owns the button's disabled state on these pages, it has to own
  // the sold-out case too, or releasing the "Select size" gate would re-enable
  // a button the theme had disabled.
  function sizeUnavailable() {
    return sizeFieldsets().some(function (fs) {
      var c = fs.querySelector('input[type="radio"]:checked');
      if (!c) return false;
      return c.getAttribute('data-option-available') === 'false' || c.getAttribute('aria-disabled') === 'true';
    });
  }

  // is this page gated at all — a bundle, or a product with size buttons?
  function gated() {
    return bundleSelects().length > 0 || sizeFieldsets().length > 0;
  }
  function allChosen() {
    var sels = bundleSelects();
    if (sels.length) return sels.every(isChosen);
    var fss = sizeFieldsets();
    if (fss.length) return fss.every(fieldsetChosen);
    return true; // neither — never gate
  }

  // Horizon re-renders the picker on every selection (a section fetch keyed on
  // option_values, then a morph). The response is rendered without ?variant=,
  // so the size can come back unchecked and the shopper would watch their own
  // pick disappear. Remember it and put it back.
  // Keyed by the radio group's name (option name + block id + product id, so
  // stable across morphs) rather than by value, so two options that share a
  // value can't cross-match.
  var chosenSizes = {};
  function reassertSize() {
    Object.keys(chosenSizes).forEach(function (name) {
      var group = document.querySelectorAll('input[type="radio"][name="' + CSS.escape(name) + '"]');
      if (!group.length) return;
      if (Array.prototype.some.call(group, function (r) { return r.checked; })) return;
      Array.prototype.forEach.call(group, function (r) {
        if (r.value === chosenSizes[name]) r.checked = true;
      });
    });
  }

  // Scroll the size section into view and briefly flash any group still missing
  // a selection. Called when add-to-cart is attempted before every size is set.
  function focusSelection() {
    var sels = bundleSelects();
    if (!sels.length) {
      var fs = sizeFieldsets().filter(function (f) { return !fieldsetChosen(f); })[0];
      if (!fs) return;
      fs.classList.add('gb-bt-flash');
      setTimeout(function () { fs.classList.remove('gb-bt-flash'); }, 1400);
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var firstEmptyWrap = null;
    sels.forEach(function (s) {
      if (!isChosen(s)) {
        var w = s.nextElementSibling;
        if (w && w.classList && w.classList.contains('gb-bt-tiles')) {
          if (!firstEmptyWrap) firstEmptyWrap = w;
          w.classList.add('gb-bt-flash');
          setTimeout(function () { w.classList.remove('gb-bt-flash'); }, 1400);
        }
      }
    });
    var target =
      firstEmptyWrap ||
      document.getElementById('simple-bundles-io-options') ||
      (sels[0] && (sels[0].closest('#simple-bundles-io-options') || sels[0].parentElement));
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Simple Bundles renders a sold-out component option as
  //   <option value="75A" data-inventory="0" disabled>75A</option>
  // That disable predates the back-in-stock drawer and now blocks the only route
  // into it: reaching the drawer means SELECTING the size that is out, and
  // build() mirrors the attribute onto the tile (a disabled <button> nothing can
  // click). Where our own stock figure confirms the option is merely sold out,
  // drop the native disable so the pick can land. Nothing sold out can reach the
  // cart as a result: updateAtcState() sees oosSelected() and blocks both the
  // add-to-cart button and dynamic checkout. An option disabled for any other
  // reason is left exactly as the app rendered it.
  // Idempotent, and re-run from scan() because the app re-renders its own select
  // and puts the attribute back.
  function freeOosOptions(sel) {
    Array.prototype.forEach.call(sel.options, function (o) {
      if (!o.value || !o.disabled) return;
      if (stateFor(sel, o.value) === 'out') o.disabled = false;
    });
  }

  function build(sel) {
    if (sel.dataset.gbTiled) return;
    sel.dataset.gbTiled = '1';
    freeOosOptions(sel);

    // gb: start with nothing preselected — the shopper must pick each size, and
    // add-to-cart is gated below until they have.
    sel.selectedIndex = -1;

    var wrap = document.createElement('div');
    wrap.className = 'gb-bt-tiles';
    var LETTERS = { XS: 0, S: 1, M: 2, L: 3, XL: 4, XXL: 5 };
    var opts = Array.prototype.filter.call(sel.options, function (o) { return o.value; });
    var tokens = opts.map(function (o) { return sizeToken(o.value); });
    if (tokens.every(function (t) { return t in LETTERS; })) {
      opts.sort(function (a, b) { return LETTERS[sizeToken(a.value)] - LETTERS[sizeToken(b.value)]; });
    }
    opts.forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gb-bt-tile';
      b.textContent = displaySize(sizeToken(o.value));
      b.dataset.value = o.value;
      if (o.disabled) b.disabled = true;
      b.addEventListener('click', function () {
        sel.value = o.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        wrap.querySelectorAll('.gb-bt-tile').forEach(function (t) {
          t.classList.toggle('is-active', t === b);
        });
        wrap.classList.remove('gb-bt-flash');
        showStockStatus(sel, o.value);
        updateAtcState();
      });
      wrap.appendChild(b);
    });
    sel.insertAdjacentElement('afterend', wrap);
    sel.classList.add('gb-bt-hidden');
    markSoldOut(sel, wrap);
  }

  // Simple Bundles doesn't mark sold-out options in its selects, so slash them
  // ourselves from the component stock map. They stay CLICKABLE on purpose:
  // selecting one shows the red "Sold out" next to the label and add-to-cart
  // is gated below instead.
  function markSoldOut(sel, wrap) {
    var comp = componentFor(sel);
    if (!comp) return;
    wrap.querySelectorAll('.gb-bt-tile').forEach(function (t) {
      var state = comp.variants[sizeToken(t.dataset.value)];
      if (state == null) state = comp.variants[t.dataset.value];
      if (state === 'out') t.classList.add('gb-bt-tile--oos');
    });
  }

  function stateFor(sel, value) {
    var comp = componentFor(sel);
    if (!comp) return null;
    var state = comp.variants[sizeToken(value)];
    if (state == null) state = comp.variants[value];
    return state;
  }

  // any chosen size that is sold out?
  function oosSelected() {
    return bundleSelects().some(function (s) {
      if (!isChosen(s)) return false;
      return stateFor(s, s.value) === 'out';
    });
  }

  // ---- back in stock -------------------------------------------------------
  // The chosen sizes that are sold out, resolved to Shopify variant IDs so the
  // Klaviyo drawer (gb-notify) can subscribe against them. For a bundle these
  // are the COMPONENT variants: a shopper waiting on a bundle is really waiting
  // on the one component that ran out.
  function compName(comp) {
    var t = comp.title || '';
    var cut = t.lastIndexOf(' - ');
    return cut !== -1 ? t.slice(0, cut) : t;
  }

  // Every option fieldset of the template's own picker in option order —
  // swatches included, unlike sizeFieldsets(), because a variant title is the
  // full combination ("Black / M") and colour is part of it.
  function selectedVariantTitle() {
    var vals = [];
    var complete = true;
    document
      .querySelectorAll(
        'variant-picker[data-template-product-match="true"] fieldset.variant-option--buttons'
      )
      .forEach(function (fs) {
        var c = fs.querySelector('input[type="radio"]:checked');
        if (!c) complete = false;
        else vals.push(c.value);
      });
    document
      .querySelectorAll(
        'variant-picker[data-template-product-match="true"] select.variant-option__select'
      )
      .forEach(function (sel) {
        if (sel.value) vals.push(sel.value);
        else complete = false;
      });
    return complete && vals.length ? vals.join(' / ') : null;
  }

  function notifyTargets() {
    var out = [];
    var sels = bundleSelects();
    if (sels.length) {
      sels.forEach(function (s) {
        if (!isChosen(s)) return;
        if (stateFor(s, s.value) !== 'out') return;
        var comp = componentFor(s);
        if (!comp || !comp.ids) return;
        var tok = sizeToken(s.value);
        var id = comp.ids[tok] != null ? comp.ids[tok] : comp.ids[s.value];
        if (id == null) return;
        out.push({ id: id, label: compName(comp) + ' \u00b7 ' + tok });
      });
      return out;
    }
    // Regular product: the single stock component is the product's own variants,
    // keyed by variant title. Fall back to the option value (single-option
    // products) and then to the id the picker rendered on the input.
    var data = stock();
    var comp = data && data.components && data.components.length === 1 ? data.components[0] : null;
    var full = selectedVariantTitle();
    sizeFieldsets().forEach(function (fs) {
      var c = fs.querySelector('input[type="radio"]:checked');
      if (!c) return;
      if (
        c.getAttribute('data-option-available') !== 'false' &&
        c.getAttribute('aria-disabled') !== 'true'
      ) {
        return;
      }
      var id = null;
      if (comp && comp.ids) {
        if (full && comp.ids[full] != null) id = comp.ids[full];
        else if (comp.ids[c.value] != null) id = comp.ids[c.value];
      }
      if (id == null) id = c.getAttribute('data-variant-id');
      if (!id) return;
      out.push({ id: id, label: c.value });
    });
    return out;
  }

  function openNotify() {
    var t = notifyTargets();
    if (!t.length) return false;
    return !!(window.gbNotify && window.gbNotify.open(t));
  }

  function atcButtons() {
    return Array.prototype.slice
      .call(
        document.querySelectorAll('button[name="add"], .add-to-cart-button, .sticky-add-to-cart__button')
      )
      .filter(function (b) {
        // the main form only: a card's quick-add button belongs to a different
        // product and has its own picker to answer for
        return !b.closest('product-card, quick-add-dialog, quick-add-component');
      });
  }

  // The button's visible label: the sticky bar has a span for it; the main
  // button carries a bare text node, which gets wrapped once so it can be
  // swapped between "Select size" / "Sold out" / the original label.
  function labelSpan(b) {
    var s = b.querySelector('.gb-atc-label, .add-to-cart-text__content');
    if (!s) {
      var tn = null;
      for (var i = 0; i < b.childNodes.length; i++) {
        var n = b.childNodes[i];
        if (n.nodeType === 3 && n.textContent.trim()) { tn = n; break; }
      }
      if (!tn) return null;
      s = document.createElement('span');
      s.className = 'gb-atc-label';
      s.textContent = tn.textContent.trim();
      b.replaceChild(s, tn);
    }
    if (!b.dataset.gbOrigLabel) b.dataset.gbOrigLabel = s.textContent.trim();
    return s;
  }

  // Natively disable add-to-cart while the selection is incomplete or a
  // sold-out size is chosen - `disabled` is the only thing that reliably stops
  // the theme's own click handlers and add animation. Writes are guarded so
  // the MutationObserver rescan doesn't loop on its own attribute changes.
  function updateAtcState() {
    if (!gated()) return;
    var chosen = allChosen();
    var oos = oosSelected() || sizeUnavailable();
    var blocked = !chosen || oos;
    var data = stock();
    var el = document.querySelector('script[data-gb-stock]');
    var selectLabel = (el && el.getAttribute('data-label-select')) || 'Izberi velikost';
    var outLabel = data ? data.labels.out : 'Razprodano';
    // A missing locale key renders as "Translation missing: en.gb.notify_cta" —
    // Liquid's `t` has no true fallback, its `default:` argument is an
    // interpolation variable, not a substitute. Treat that as no label at all so
    // the button degrades to the plain sold-out state instead of shouting the
    // translation key at the shopper.
    var notifyLabel = (el && el.getAttribute('data-label-notify')) || '';
    if (/^translation missing/i.test(notifyLabel)) notifyLabel = '';
    // A sold-out size we can actually subscribe to turns the button into the
    // back-in-stock trigger instead of a dead "Sold out": it stays enabled and
    // clickable, and the capture handler below opens the drawer rather than
    // letting the add through. Without a resolvable variant id it stays dead.
    var canNotify = chosen && oos && !!notifyLabel && notifyTargets().length > 0;
    atcButtons().forEach(function (b) {
      var dead = blocked && !canNotify;
      if (b.disabled !== dead) b.disabled = dead;
      b.classList.toggle('gb-atc-oos', dead);
      b.classList.toggle('gb-atc-notify', canNotify);
      var span = labelSpan(b);
      if (!span) return;
      var want = !chosen
        ? selectLabel
        : canNotify
          ? notifyLabel
          : oos
            ? outLabel
            : b.dataset.gbOrigLabel;
      if (want && span.textContent.trim() !== want) span.textContent = want;
    });

    // Dynamic checkout (PayPal / Shop Pay) posts the variant the page resolved
    // and would skip the gate entirely, so block it alongside the button. Taps
    // there still bubble to .product-form-buttons, where the handler further
    // down walks the shopper to the sizes.
    document.querySelectorAll('.accelerated-checkout-block').forEach(function (w) {
      if (w.classList.contains('gb-atc-blocked') !== blocked) {
        w.classList.toggle('gb-atc-blocked', blocked);
      }
    });
  }

  // A size group whose EVERY size is sold out means the bundle cannot be
  // bought in any combination, but the Simple Bundles parent product still
  // reports "available", so the USP stock row renders green. Flip it to the
  // red "out of stock" row here. One-directional on purpose: stock is static
  // per page load, and a liquid-rendered "out" row must never be un-hidden.
  function groupFullyOut() {
    return bundleSelects().some(function (s) {
      var comp = componentFor(s);
      if (!comp) return false;
      var opts = Array.prototype.filter.call(s.options, function (o) { return o.value; });
      if (!opts.length) return false;
      return opts.every(function (o) {
        var state = comp.variants[sizeToken(o.value)];
        if (state == null) state = comp.variants[o.value];
        return state === 'out';
      });
    });
  }

  function updateUspStock() {
    if (!bundleSelects().length || !groupFullyOut()) return;
    var rowIn = document.querySelector('[data-gb-stock-row="in"]');
    var rowOut = document.querySelector('[data-gb-stock-row="out"]');
    if (rowIn && !rowIn.hidden) rowIn.hidden = true;
    if (rowOut && rowOut.hidden) rowOut.hidden = false;
  }

  // Localized component labels (Bra/Thong/Garter Belt ...). Simple Bundles emits
  // the size-group labels in English from the option names; relabel them per
  // storefront language from the [data-gb-comp] map rendered by gb-size-links.
  var compLabelsCache;
  function compLabels() {
    if (compLabelsCache !== undefined) return compLabelsCache;
    var el = document.querySelector('script[data-gb-comp]');
    try { compLabelsCache = el ? JSON.parse(el.textContent) : null; }
    catch (e) { compLabelsCache = null; }
    return compLabelsCache;
  }
  function localizeComp(txt) {
    var map = compLabels();
    if (!map) return txt;
    var t = txt.trim();
    if (map[t]) return map[t];
    // composite option names ("Thong & Garter Belt"): swap each known type,
    // longest first so "Garter Belt" isn't half-replaced inside a longer phrase
    var keys = Object.keys(map).sort(function (a, b) { return b.length - a.length; });
    var out = t;
    keys.forEach(function (k) {
      out = out.replace(
        new RegExp('\\b' + k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'g'),
        map[k]
      );
    });
    return out;
  }
  function relabel(sel) {
    var label = document.querySelector('label[for="' + sel.id + '"]');
    if (!label) return;
    var tn = null;
    for (var i = 0; i < label.childNodes.length; i++) {
      var n = label.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) { tn = n; break; }
    }
    if (!tn) return;
    if (!label.dataset.gbOrigLabel) label.dataset.gbOrigLabel = tn.textContent.trim();
    var loc = localizeComp(label.dataset.gbOrigLabel);
    if (tn.textContent.trim() !== loc) tn.textContent = loc;
  }

  function scan() {
    document.querySelectorAll('select[name^="properties["]').forEach(function (s) {
      build(s);
      freeOosOptions(s);
      relabel(s);
      // Re-assert the stock label for every already-chosen component, not just
      // the one last clicked. The theme morphs the picker on each selection,
      // which wipes the appended .gb-stock-status spans; without this, only the
      // component that triggered the last render keeps its "In stock" label on
      // multi-group bundles. renderStatus reuses the existing span, so idempotent.
      if (s.value) showStockStatus(s, s.value);
    });
    reassertSize();
    updateAtcState();
    applyPickerStatus();
    updateUspStock();
  }

  // Regular (non-bundle) products: keep the stock status in the native
  // variant picker's <legend> in sync with the checked radio. Runs on load
  // (a variant is preselected) and again after every DOM change, because
  // Horizon re-renders the picker via a section fetch + morph on variant
  // change, which replaces the legend and would otherwise wipe the status.
  // Writes are guarded so the MutationObserver rescan doesn't loop.
  function applyPickerStatus() {
    var data = stock();
    if (!data || data.components.length !== 1) return;
    document
      .querySelectorAll('variant-picker fieldset.variant-option--buttons')
      .forEach(function (fs) {
        var checked = fs.querySelector('input[type="radio"]:checked');
        if (!checked) return;
        var state = data.components[0].variants[checked.value];
        if (state == null) return;
        var legend = fs.querySelector('legend');
        if (!legend) return;
        var span = legend.querySelector('.gb-stock-status');
        if (
          span &&
          span.classList.contains('gb-stock-status--' + state) &&
          span.textContent === data.labels[state]
        )
          return;
        renderStatus(legend, state, data.labels);
      });
  }

  // ---- per-size stock status ("In stock" / "Almost sold out" / "Sold out")
  // next to the size-group label. Stock data + localized labels come from the
  // [data-gb-stock] JSON rendered by snippets/gb-size-links.liquid:
  //   { components: [ { title, variants: { "<variant title>": state } } ] }
  // where state is "out" / "low" / "ok". The quantities and the low-stock
  // threshold stay server-side so the page source can't be scraped for stock.
  //
  // Bundle option values still carry the components' ORIGINAL (pre-rename)
  // titles, so option values cannot be matched against current component
  // titles directly. Each select is matched to a component by the words in its
  // Simple Bundles label instead (Bra -> Nedrček etc.), falling back to
  // whichever component covers the group's size tokens.
  var LABEL_WORDS = [
    ['bra', ['nedrček', 'nedrcek', 'bra']],
    ['thong', ['tangice', 'thong']],
    ['garter', ['pas', 'garter']],
    ['brief', ['hlačke', 'hlacke', 'brief', 'pantie']],
    ['pantie', ['hlačke', 'hlacke', 'brief', 'pantie']],
    ['belt', ['pas', 'belt']],
    ['bodysuit', ['body']],
    ['body', ['body']],
  ];
  var stockData = null;
  function stock() {
    if (stockData) return stockData;
    var el = document.querySelector('script[data-gb-stock]');
    if (!el) return null;
    var parsed = null;
    try { parsed = JSON.parse(el.textContent); } catch (e) { return null; }
    if (!parsed || !parsed.components) return null;
    stockData = {
      // Key every variant by its EU size as well as whatever the storefront
      // called it, so the lookups below work whether the titles arrived
      // translated (2A, on /it-it/) or not (75A).
      components: parsed.components.map(function (c) {
        var variants = {};
        Object.keys(c.variants).forEach(function (title) {
          variants[title] = c.variants[title];
          var eu = euSize(title);
          if (!(eu in variants)) variants[eu] = c.variants[title];
        });
        // The variant-id map gets the same double-keying: the back-in-stock
        // drawer looks an id up by the token the bundle select carries, which
        // is untranslated (75A) even where the rendered titles are IT (2A).
        var ids = {};
        Object.keys(c.ids || {}).forEach(function (title) {
          ids[title] = c.ids[title];
          var eu = euSize(title);
          if (!(eu in ids)) ids[eu] = c.ids[title];
        });
        return { title: c.title, variants: variants, ids: ids };
      }),
      labels: {
        ok: el.getAttribute('data-label-ok') || 'In stock',
        low: el.getAttribute('data-label-low') || 'Almost sold out',
        out: el.getAttribute('data-label-out') || 'Sold out',
      },
    };
    return stockData;
  }

  function componentFor(sel) {
    var data = stock();
    if (!data) return null;
    if (data.components.length === 1) return data.components[0];
    // Primary, language-independent match: the Nth bundle select maps to the Nth
    // stock component (both come from the bundle's component_products order). The
    // component titles are localized per storefront ("Nedrček"/"Sujetador"), so the
    // English option-name/word heuristics below fail on non-EN markets. Guard with
    // a size-coverage check so a mismatched order can't bind the wrong component.
    var sels = bundleSelects();
    var idx = sels.indexOf(sel);
    if (idx !== -1 && data.components.length === sels.length && data.components[idx]) {
      var cand = data.components[idx];
      var toks = Array.prototype.filter
        .call(sel.options, function (o) { return o.value; })
        .map(function (o) { return sizeToken(o.value); });
      if (toks.length && toks.every(function (t) { return t in cand.variants; })) return cand;
    }
    // The select name embeds the exact bundle option name: properties[<name>].
    // Match it to the component whose title (minus a trailing " - <color>") ends
    // with that name, preferring the tightest fit. This is the reliable path and
    // fixes overlapping names, e.g. "Garter Belt" must not also grab
    // "Thong & Garter Belt" (which the substring heuristics below can't tell
    // apart, leaving those components with no stock label).
    var nameMatch = sel.name && sel.name.match(/^properties\[(.+)\]$/);
    if (nameMatch) {
      var opt = nameMatch[1].trim().toLowerCase();
      var best = null;
      var bestExtra = Infinity;
      data.components.forEach(function (c) {
        var t = c.title.toLowerCase();
        var cut = t.lastIndexOf(' - ');
        if (cut !== -1) t = t.slice(0, cut);
        var extra = null;
        if (t === opt) extra = 0;
        else if (
          t.length > opt.length &&
          t.slice(t.length - opt.length) === opt &&
          t.charAt(t.length - opt.length - 1) === ' '
        )
          extra = t.length - opt.length;
        if (extra !== null && extra < bestExtra) {
          best = c;
          bestExtra = extra;
        }
      });
      if (best) return best;
    }
    // Most option values are "<component title> - <size>"; when that title
    // still matches a current component exactly, that beats every heuristic.
    // (Sizes never contain " - ", so slicing off the last segment is safe.)
    var withTitle = Array.prototype.filter.call(sel.options, function (o) {
      return o.value && o.value.indexOf(' - ') !== -1;
    })[0];
    if (withTitle) {
      var prefix = withTitle.value.slice(0, withTitle.value.lastIndexOf(' - ')).toLowerCase();
      var byTitle = data.components.filter(function (c) {
        return c.title.toLowerCase() === prefix;
      });
      if (byTitle.length === 1) return byTitle[0];
    }
    var label = document.querySelector('label[for="' + sel.id + '"]');
    var labelText = (label ? label.textContent : sel.name).toLowerCase();
    for (var i = 0; i < LABEL_WORDS.length; i++) {
      if (labelText.indexOf(LABEL_WORDS[i][0]) === -1) continue;
      var words = LABEL_WORDS[i][1];
      var hit = data.components.filter(function (c) {
        var t = c.title.toLowerCase();
        return words.some(function (w) { return t.indexOf(w) !== -1; });
      });
      if (hit.length === 1) return hit[0];
    }
    // fallback: the only component whose variant titles cover this group's sizes
    var tokens = Array.prototype.filter
      .call(sel.options, function (o) { return o.value; })
      .map(function (o) { return sizeToken(o.value); });
    var covering = data.components.filter(function (c) {
      return tokens.every(function (t) { return t in c.variants; });
    });
    return covering.length === 1 ? covering[0] : null;
  }

  function showStockStatus(sel, value) {
    var data = stock();
    var label = document.querySelector('label[for="' + sel.id + '"]');
    if (!data || !label) return;
    var comp = componentFor(sel);
    if (!comp) return;
    var state = comp.variants[sizeToken(value)];
    if (state == null) state = comp.variants[value];
    if (state == null) return;
    renderStatus(label, state, data.labels);
  }

  function renderStatus(host, state, labels) {
    var cls = 'gb-stock-status gb-stock-status--' + state;
    var txt = labels[state];
    var span = host.querySelector('.gb-stock-status');
    // no-op if already showing this exact status: the scan() re-assert runs on
    // every MutationObserver fire, so redundant writes here would loop the observer
    if (span && span.className === cls && span.textContent === txt) return;
    if (!span) {
      span = document.createElement('span');
      host.appendChild(span);
    }
    span.textContent = txt;
    span.className = cls;
  }

  // Regular variant products: the native variant picker fires change on its
  // radios; mirror the status into that option's <legend>. Single-component
  // stock data on these pages is the product's own variants.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.closest) return;
    var fieldset = input.closest('variant-picker fieldset.variant-option--buttons');
    if (!fieldset || input.type !== 'radio') return;
    chosenSizes[input.name] = input.value;
    updateAtcState();
    var data = stock();
    if (!data || data.components.length !== 1) return;
    var state = data.components[0].variants[input.value];
    if (state == null) return;
    renderStatus(fieldset.querySelector('legend'), state, data.labels);
  });

  // Gate every add-to-cart trigger (main button + sticky bar). Capture phase so
  // this runs before Horizon's own /handleClick and the Simple Bundles handler;
  // if any size is unset we stop the add and scroll to the sizes instead.
  function isAddTrigger(el) {
    return !!(el.closest('button[name="add"], .add-to-cart-button, .sticky-add-to-cart__button'));
  }
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest || !isAddTrigger(t)) return;
      if (gated() && !allChosen()) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        focusSelection();
        return;
      }
      // a sold-out size is selected: swallow the click so nothing can be added,
      // then open the back-in-stock drawer for that variant
      if (oosSelected() || sizeUnavailable()) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        openNotify();
      }
    },
    true
  );

  // The blocked button has pointer-events: none, so taps land on its wrapper;
  // catch them there and walk the shopper to the size groups.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var wrap = t.closest('add-to-cart-component, .sticky-add-to-cart__bar, .product-form-buttons');
    if (!wrap) return;
    if (wrap.querySelector('.gb-atc-notify')) {
      openNotify();
      return;
    }
    if (!wrap.querySelector('.gb-atc-oos')) return;
    focusSelection();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
